import GeoJsonFormat from 'ol/format/GeoJSON.js';
import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import VectorLayer from '@planet/maps/layer/Vector.js';
import VectorSource from '@planet/maps/source/Vector.js';

import {getLayerStyle} from './util.js';
import {useMapTheme} from './context/MapThemeProvider.jsx';

const format = new GeoJsonFormat();

const GeojsonLayer = ({features, layerProps, sourceProps, visible, style}) => {
  const mapTheme = useMapTheme();
  const layerStyle = getLayerStyle(mapTheme, style);

  const olFeatures = useMemo(
    () =>
      format.readFeatures({
        type: 'FeatureCollection',
        features: features.filter(Boolean).map((feature, index) => ({
          ...feature,
          id: feature.id || index,
        })),
      }),
    [features],
  );

  return (
    <VectorLayer style={layerStyle} visible={visible} {...layerProps}>
      <VectorSource features={olFeatures} {...sourceProps} />
    </VectorLayer>
  );
};

GeojsonLayer.propTypes = {
  /**
   * Array of geojson features to display
   */
  features: PropTypes.array,
  /**
   * Additional properties for the VectorLayer
   */
  layerProps: PropTypes.object,
  /**
   * Additional properties for the VectorSource
   */
  sourceProps: PropTypes.object,
  /**
   * If `true`, the component is visible
   */
  visible: PropTypes.bool,
  /**
   * The style for the VectorLayer
   */
  style: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.func,
    PropTypes.object,
    PropTypes.string,
  ]),
};

GeojsonLayer.defaultProps = {
  visible: true,
};

export default GeojsonLayer;
